import { Component } from 'react';

import { IdleTimerProvider } from 'react-idle-timer'
import { IDLE_LAST_ACTIVE_STORAGE_KEY, isLoggedIn, logout } from './authservice';

const ALLOWED_IDLE_TIME = 30 * 60 * 1000; // 30 mins
class AppIdleTimer extends Component {
    constructor(props){
        super(props);
        if (isLoggedIn() && this.isLastActiveExpired()) {
            this.onIdle();
        }
    }

    onIdle = () => {
        console.info("Logging out as user is idle")
        logout();
    }

    isLastActiveExpired = () => {
        const lastActiveItem = localStorage.getItem(IDLE_LAST_ACTIVE_STORAGE_KEY);
        if (!lastActiveItem) {
            return false;
        }
        const lastActiveTime = new Date(lastActiveItem);
        const lastMs = lastActiveTime.getTime();
        if (Number.isNaN(lastMs)) {
            return false;
        }
        const currentTime = new Date();
        const diffTime = Math.abs(currentTime.getTime() - lastMs);
        return diffTime > ALLOWED_IDLE_TIME;
    }

    updateActiveTime = () => {
        if (isLoggedIn()) {
            localStorage.setItem(IDLE_LAST_ACTIVE_STORAGE_KEY, new Date().toISOString());
        }
    }

    render() {
        const { children } = this.props;
        return (
            <IdleTimerProvider
                onIdle={this.onIdle}
                debounce={100}
                crossTab
                timeout={ALLOWED_IDLE_TIME}
                onAction={this.updateActiveTime}
            >
                {children}
            </IdleTimerProvider>
        )
    }
}

export default AppIdleTimer;